import { RoutesProvider } from 'context/RoutesContext';

export const BaseContext = ({ children }) => (
  <RoutesProvider>{children}</RoutesProvider>
);
